export default "__VITE_ASSET__7e07add1__"